import {
  transformDOMQLEmotion,
  createEmotion,
  create,
  activateConfig,
  deepClone
} from 'smbls'

import {
  prepareFrameProps,
  prepareCode,
  prepareUtils,
  prepareInitOptions
} from './renderer-shared'

const prepareDesignSystem = async (scope, rootState) => {
  const { cache } = scope
  const globalTheme =
    rootState.designSystem?.globalTheme ||
    rootState.sceneTheme ||
    rootState.globalTheme
  const { useLibrary } = scope
  const hasCache = cache?.designSystem

  const lib = useLibrary
    ? hasCache || deepClone(rootState.designSystem)
    : deepClone(await this.getDefaultDesignSystem())

  return {
    ...lib,
    globalTheme
    // reset: {
    //   body: {
    //     position: 'absolute',
    //     inset: '0 0 0 0'
    //   }
    // }
  }
}

const prepareComponent = (scope, state, code) => {
  const props = scope.frameProps || {}
  const extend = []
  if (state.state) {
    extend.push({ state: state.state })
  }
  const demoObj = prepareCode(code)
  const demoComponent = demoObj
  return deepClone({
    extends: extend.concat([demoComponent]),
    fontSize: props.base && `${props.base}px`,
    '--spacing-ratio': state.ratio,
    variant: state.variant,
    transition: 'all, B, defaultBezier'
  })
}

const prepareComponents = async (scope, rootState) => {
  const { cache, useLibrary } = scope
  const hasCache = cache?.components

  return useLibrary
    ? hasCache || deepClone(rootState.components)
    : deepClone(await this.getDefaultComponents())
}

const prepareDemoApp = (scope, state, code) => {
  const { cache, useLibrary, renderPureComponent } = scope // eslint-disable-line
  if (renderPureComponent) {
    return code
  }
  const element = state.__element
  const appJsFromFiles = (cache?.files || state.root.files)['app.js']
  const appJs = element.call(
    'evalStringToObject',
    appJsFromFiles && appJsFromFiles.code
  )
  return deepClone({
    extends: ['Flex', scope.useAppjs && appJs],
    ...prepareFrameProps(scope, state),
    data: {},
    demoComponent: prepareComponent(scope, state, code),
    ...scope.appEvents,
    ...fixScratchSwitchingOnListener
  })
}

export const renderStateComponentDashboard = async (
  code,
  el,
  s,
  scope = {}
) => {
  if (!code || el.data?.demoFrameElement) {
    return
  }

  // if (el.data?.demoFrameElement) el.data?.demoFrameElement.remove()

  const rootState = s.root
  const frameWindow = el.node.contentWindow
  const currentDocument = el.node.contentDocument || document
  if (!currentDocument) {
    return
  }

  const emotionKey = (scope.key || el.getAppKey() || 'demo')
    .replace(/[^A-Za-z]+/gu, '')
    .toLowerCase()
  const emotion = createEmotion(emotionKey, currentDocument.head)
  const emotionDefine = transformDOMQLEmotion(emotion)

  // prepare cache
  const cache =
    scope.cache || el.lookup((el2) => el2.scope.__cache)?.scope.__cache
  if (!scope.cache) scope.cache = cache

  // prepare domql app
  const demoApp = prepareDemoApp(scope, s, code)

  if (el.node.offsetParent === null) {
    return
  }

  try {
    el.data.demoFrameElement = await create.call(frameWindow, demoApp, {
      key: scope.renderPureComponent ? s.key : 'demo',
      document: scope.document || currentDocument,
      designSystem: await prepareDesignSystem(scope, rootState),
      components: await prepareComponents(scope, rootState),
      pages: preparePages(scope, rootState),
      files: prepareFiles(scope, rootState),
      utils: prepareUtils(scope, rootState),
      snippets: prepareSnippets(scope, rootState),
      methods: el.prepareMethods(scope, rootState),
      registry: emotionDefine,
      initOptions: prepareInitOptions(scope, emotion),
      dependencies: !scope.preventDependencies && el.getDependencies(),
      window: frameWindow,
      socket: el.context.socket,
      domqlOptions: {
        alowRefReference: true
      },
      editor: {
        verbose: false,
        inspect: false,
        liveSync: false,
        remote: false
      },
      // editor: {
      //   inspect: true,
      //   sync: false,
      //   onInspect: (key, _, __, opts) => router(window.location.pathname + '/editor/' + key, el.__ref.root, {}, opts)
      // },
      router: scope.useRouter
        ? {
            pushState: false,
            removeOldElement: true,
            contentElementKey: 'demoComponent'
          }
        : false
    })
  } catch (e) {
    el.error(e)
  }

  return el.data.demoFrameElement
}
